import PageLayout from "../../components/feature/PageLayout";
import InfoPageHero from "../../components/feature/InfoPageHero";
import InfoPageFinalCTA from "../../components/feature/InfoPageFinalCTA";
import InfoPageFooter from "../../components/feature/InfoPageFooter";
import StepsSection from "./components/StepsSection";
import GuideSection from "./components/GuideSection";
import WorriesSection from "./components/WorriesSection";
import { useFirstTimeData } from "../../lib/useMockData";

export default function FirstTime() {
  const { heroData, finalCTA } = useFirstTimeData();
  return (
    <PageLayout>
      <InfoPageHero
        label="FIRST TIME"
        title={heroData.title}
        subtitle={heroData.subtitle}
        image={heroData.image}
        alt="初めての方へ"
      />
      <StepsSection />
      <GuideSection />
      <WorriesSection />
      <InfoPageFinalCTA
        title={finalCTA.title}
        subtitle={finalCTA.subtitle}
        ctas={finalCTA.ctas}
      />
      <InfoPageFooter />
    </PageLayout>
  );
}
